export const translations = {
  en: {
    accepted: 'accepted',
    age: 'Age',
    allSelectedInvestments: 'All selected investments must be accepted and have payment slip method. Adjust your selection to send slips.',
    alreadySent: 'Invitation has been already sent to this email address.',
    amount: 'amount',
    amountOfSharesBiggerThanDeclared: 'Amount of shares cannot be more than declared number of shares ',
    analysis: 'analysis',
    answer: 'Answer',
    archived: 'archived',
    author: 'author',
    averageInvestment: 'Average investment',
    cancel: 'Cancel',
    cantAddInvestment: `You can’t add the investment in this pitch. Contact administrator to receive aid`,
    change: 'You are about to change',
    changed: 'have been changed',
    comingUp: 'coming up',
    Companies: 'Companies',
    company: 'Company...',
    companyDoesNotExist: 'Company with this org. number does not exists',
    companyName: 'company name',
    confirm: 'Confirm',
    couldNotSend: 'Could not send invitation. Please check if email address is valid.',
    createdDate: 'created date',
    customerStatus: 'customer status',
    cyi: 'cyi',
    date: 'date',
    dateOfAddition: 'date of addition',
    dayLabels: { su: 'Sun', mo: 'Mon', tu: 'Tue', we: 'Wed', th: 'Thu', fr: 'Fri', sa: 'Sat' },
    defaultError: 'Oops! Something went wrong.',
    deleted: 'deleted',
    draft: 'draft',
    eligible: 'eligible',
    email: 'email',
    endDate: 'end date',
    expiredTokenError: 'Your token has expired. <br> Please login again.',
    exportError: 'There seems to be a problem with this export. Contact administrator to receive aid.',
    exportAlreadyExists: 'Export for this pitch and class already exists.',
    female: 'Female',
    fileFail: 'Cannot retrieve/check document.',
    fileHasBeen: 'File has been',
    fileNotReady: 'File is not ready yet.<br> Please try again later.',
    filePreviewNotAvailable: 'File preview is not available.',
    flag: 'flag',
    flagged: 'flagged',
    incorrectInvestments: 'There are investments pending or unsigned. Set them to accepted or rejected.',
    Individuals: 'Individuals',
    ineligible: 'ineligible',
    inQuestion: 'in question',
    invalidDate: 'Invalid date format.',
    invalidPNR: 'Invalid PNR',
    invalidBackupToken: 'Backup token invalid.',
    invalidCredentials: 'Invalid credentials given.',
    invalidToken: 'Token invalid.',
    investment: 'investment',
    investmentCompany: 'investment company',
    investmentHasBeenMade: 'Investment has been made.',
    investmentsMadeBy: 'Investments made by',
    invisible: 'invisible',
    isMissingPNR: 'is missing PNR.',
    KYCInv: 'KYC inv.',
    male: 'Male',
    maxGoal: 'Max. Goal',
    maxInvestment: 'Max. investment',
    maxValue: 'max value',
    medianInvestment: 'Median investment',
    minGoal: 'Min. Goal',
    minInvestment: 'Min. investment',
    minValue: 'min value',
    missingPNRs: `Some accounts are missing PNR's.`,
    missingAllocationDate: 'Please provide allocation date',
    missingSelfPublishFieldsError: 'Self publish cannot be accepted due to missing fields. Check progress tab for more info.',
    modifiedDate: 'modified date',
    monthLabels: {
      1: 'Jan',
      2: 'Feb',
      3: 'Mar',
      4: 'Apr',
      5: 'May',
      6: 'Jun',
      7: 'Jul',
      8: 'Aug',
      9: 'Sep',
      10: 'Oct',
      11: 'Nov',
      12: 'Dec'
    },
    multiSuffix: '(s)',
    name: 'name',
    nameHeader: 'Name...',
    noAgreement: 'Agreement is not signed or not generated yet.',
    // eslint-disable-next-line max-len
    noAvailableElement:
      'Element you are trying to browse/edit is no longer available. Please go back to list view to make sure they still exist',
    noOfInvestors: 'no. of investors',
    notPaidInvestments: `Some accepted investments aren't paid yet. Make sure they are before proceeding to export.`,
    offerWithoutSubscriptions: `Offer hasn't got any subscription.`,
    paid: 'paid',
    passedCT: 'Passed CT (among all investments)',
    payment: 'payment',
    paymentSlipsSent: 'payment slip(s) have been sent.',
    paymentStatus: 'payment status',
    pending: 'pending',
    permissionError: `You don't have permission to login.`,
    pitch: 'pitch',
    pitchType: 'pitch type',
    private: 'private',
    public: 'public',
    Question: 'Question:',
    question: 'question',
    questionOrPitch: 'Question or pitch...',
    rejected: 'rejected',
    retrieveMissingPNRs: 'Some of the investors lack their PNR’s. \n Use “retrieve PNR” buttons to get them before trying again.',
    save: 'Save',
    sendSlipsError: 'Total subscribed value must be the same as threshold value. Adjust your investments to send slips.',
    serverError: 'Internal server error.',
    shares: 'shares',
    shareholderEmailMismatch: 'Shareholder field \'email\' doesn\'t match',
    shareholderPnrMismatch: 'Shareholder field \'pnr\' doesn\'t match',
    shareholderOrgNrMismatch: 'Shareholder field \'organization_number\' doesn\'t match',
    shareholderDuplicated: 'Duplicated shareholders in registry.',
    subscribe: 'subscribe',
    subscribed: 'subscribed',
    subscription: 'subscription',
    textOrPitch: 'Text or pitch...',
    toHave: 'to have',
    totalInv: 'total inv.',
    totalInvestedAmount: 'total invested amount',
    totalRaised: 'Total raised',
    unequalValue: 'Threshold value differs from total amount of shares accepted and paid.',
    unexpectedError: 'Unexpected error.',
    unflagged: 'unflagged',
    unlisted: 'unlisted',
    unpaid: 'unpaid',
    unsigned: 'unsigned',
    unsubscribe: 'unsubscribe',
    unsubscribed: 'unsubscribed',
    uploaded: 'uploaded',
    User: 'User...',
    user: 'user',
    validEmail: 'Enter a valid email address.',
    visible: 'visible',
    usersChartLabels: ['Registered', 'Activated', 'KYC/CT started', 'KYC/CT', 'With draft', 'With unsigned investment', 'Invested'],
    warning: 'Warning',
    None: 'None',
    Pep: 'Pep',
    Sanction: 'Sanctions',
    PepAndSanction: 'Pep And Sanctions'
  },
  no: {
    accepted: 'godtatt',
    Added: 'Nye',
    age: 'Alder',

    allSelectedInvestments:// eslint-disable-next-line max-len
      'De valgte investeringene ,å være akseptert, og ha betalingsblankett valgt som betalingsalternativ. Gjør de nødvendige justeringen for å sende ut betalingsinformajson.',
    alreadySent: 'En invitasjon har allerede blitt sendt til denne epost-adressen.',
    amount: 'bel\u00f8p',
    amountOfSharesBiggerThanDeclared: 'Det totale antall aksjer kan ikke overstige antall aksjer i emisjonen ',
    analysis: 'analyser',
    answer: 'Svar',
    archived: 'arkivert',
    author: 'forfatter',
    averageInvestment: 'Gjennomsnittlig ivestering',
    cancel: 'Avbryt',
    cantAddInvestment: 'Du kan ikke legge inn denne investeringen. Kontakt administrator for å få hjelp.',
    change: 'Du er i ferd med å endre',
    Changed: 'Endret',
    changed: 'har blitt endret',
    comingUp: 'kommer',
    Companies: 'Selskap',
    company: 'Selskap...',
    companyDoesNotExist: 'Firma med dette org. nr eksisterer ikke',
    companyName: 'selskapsnavn',
    confirm: 'bekreft',
    couldNotSend: 'Klarte ikke å sende invitasjon. Sjekk at epost-adressen er riktig.',
    createdDate: 'opprettelsesdato',
    customerStatus: 'Kundestatus',
    cyi: 'i \u00e5r',
    date: 'dato',
    dateOfAddition: 'dato for tillegg',
    dayLabels: { su: 'Søn', mo: 'Man', tu: 'Tir', we: 'Ons', th: 'Tor', fr: 'Fre', sa: 'Lør' },
    defaultError: 'Oj. Noe gikk galt.',
    Deleted: 'Slettede',
    deleted: 'slettet',
    draft: 'kladd',
    eligible: 'kvalifisert',
    email: 'epost',
    endDate: 'sluttdato',
    expiredTokenError: 'Din token har utløpt. <br> Du må logge inn på nytt.',
    exportError: 'Det er desverre et problem med eskorten. Ta kontakt med administrator for videre hjelp.',
    exportAlreadyExists: 'Eksport for denne pitch og klasse eksisterer allerede.',
    female: 'Kvinne',
    fileFail: 'Kan ikke lese/sjekke dokumentet.',
    fileHasBeen: 'Filen har blitt',
    fileNotReady: 'Filen er ikke klar ennå.<br>  Prøv igjen senere.',
    filePreviewNotAvailable: 'Forhåndsvisning av filen er ikke tilgjengelig',
    flag: 'merke',
    flagged: 'merket',
    incorrectInvestments: 'Det ligger usignerte eller ventende tegninger. De må enten godkjennes eller avslås.',
    Individuals: 'Privatpersoner',
    ineligible: 'ukvalifisert',
    inQuestion: 'uavklart',
    invalidDate: 'Ugyldig datoformat.',
    invalidPNR: 'Ugyldig personnummer',
    invalidBackupToken: 'ugyldig reservepassord',
    invalidCredentials: 'Feil brukernavn eller passord oppgitt.',
    invalidToken: 'ugylding token',
    investment: 'investert',
    investmentCompany: 'Investeringsselskap',
    investmentHasBeenMade: 'Investeringen er lagt til.',
    investmentsMadeBy: 'Investeringer utf\u00f8rt av',
    invisible: 'Ikke synlig',
    isMissingPNR: 'mangler personnummer.',
    KYCInv: 'KYC-investering',
    male: 'Mann',
    maxGoal: 'Maksimumsmål',
    maxInvestment: 'Maksimumsinvestering',
    maxValue: 'maksimumsverdi',
    medianInvestment: 'Median investert',
    minGoal: 'Minimumsmål',
    minInvestment: 'Minimumsinvestering',
    minValue: 'minimumsverdi',
    missingAllocationDate: 'Oppgi tildelingsdato',
    missingPNRs: `Noen kontoer mangler personnummer`,
    missingSelfPublishFieldsError: 'Selvpublisering kan ikke godtas på grunn av manglende felt. Sjekk fremdriftsfanen for mer info.',
    modifiedDate: 'modifisert dato',
    monthLabels: {
      1: 'Jan',
      2: 'Feb',
      3: 'Mar',
      4: 'Apr',
      5: 'Mai',
      6: 'Jun',
      7: 'Jul',
      8: 'Aug',
      9: 'Sep',
      10: 'Okt',
      11: 'Nov',
      12: 'Des'
    },
    multiSuffix: '(er)',
    name: 'navn',
    nameHeader: 'Navn...',
    noAgreement: 'Avtalen er ikke signert eller ikke enda generert',
    // eslint-disable-next-line max-len
    noAvailableElement:
      'Elementet du prøver å se / endre er ikke lengre tilgjengelig. Gå ett steg tilbake til listen og se om elementet fortsatt eksisterer',
    noOfInvestors: 'antall investorer',
    // eslint-disable-next-line max-len
    notPaidInvestments: `Noen av de bekreftede investeringene er ennå ikke betalt. De må markeres som betalt før du kan fortsette eksporten.`,
    offerWithoutSubscriptions: `Tilbudet har ingen abonnenter`,
    paid: 'betalt',
    passedCT: 'Bestått hensiktsmessighetstest (av alle investeringene)',
    payment: 'betaling',
    paymentSlipsSent: 'betalinsblankett(er) har blitt sendt.',
    paymentStatus: 'betalingsstatus',
    pending: 'ventende',
    permissionError: 'Du har ikke rettigheter til å logge inn.',
    pitch: 'pitch',
    pitchType: 'pitch-type',
    private: 'privat',
    public: 'offentlig',
    Question: 'Spørsmål:',
    question: 'sp\u00f8rsm\u00e5l',
    questionOrPitch: 'Sp\u00f8rsm\u00e5l eller pitch...',
    rejected: 'avvist',
    retrieveMissingPNRs: 'Noen investorer mangler personnummeret. \n Trykk på "Hent Personnummer" før du prøver igjen.',
    save: 'Lagre',
    sendSlipsError: 'Totaltbeløpet må være likt emisjonsbeløpet. Juster totalbeløpet før du sender ut betalingsinformasjon. ',
    serverError: 'Intern systemfeil',
    shares: 'aksjer',
    shareholderEmailMismatch: 'Aksjonærens felt ‘email’ stemmer ikke',
    shareholderPnrMismatch: 'Aksjonærens felt ‘pnr’ stemmer ikke',
    shareholderOrgNrMismatch: 'Aksjonærens felt ‘pnr’ stemmer ikke',
    shareholderDuplicated: 'Dublikate aksjonærer i databasen.',
    subscribe: 'abonnere',
    subscribed: 'abonnert',
    subscription: 'abonnement',
    textOrPitch: 'Tekst eller pitch...',
    toHave: 'med',
    totalInv: 'totalt investert',
    totalInvestedAmount: 'totalt investert bel\u00f8p',
    totalRaised: 'Totalt innhentet',
    unequalValue: 'Emisjonsbeløpet stemmer ikke overens med det investeringsbeløpet.',
    unexpectedError: 'Uventet feil.',
    unflagged: 'umerket',
    unlisted: 'ulistet',
    unpaid: 'ikke betalt',
    unsigned: 'usignert',
    unsubscribe: 'avslutte abonnementet',
    unsubscribed: 'utmeldt',
    uploaded: 'lastet opp',
    user: 'bruker',
    User: 'Bruker...',
    validEmail: 'Skriv inn en gyldig epost-adresse.',
    visible: 'synlig',
    usersChartLabels: [
      'Registrert',
      'Arkivert',
      'KYC/CT startet',
      'KYC/CT',
      'Inkludert kladder',
      'Inkludert usignerte investeringer',
      'Investert'
    ],
    warning: 'Advarsel',
    None: 'None',
    Pep: 'Pep',
    Sanction: 'Sanctions',
    PepAndSanction: 'Pep And Sanctions'
  }
};
